import { AmountOption } from "../../interfaces";

interface GetAmountBoxHintTextParams {
    amountError: boolean;
    amount: string;
    discount?: number;
    discountMinimumValue?: number;
}

export const isAmountValid = (amount: string) => {
    return Number(amount) >= 50 && Number(amount) <= 10000;
};

export const getDiscountedValue = (
    amount: string,
    discount?: number,
    discountMinimumValue?: number
) => {
    if (!discount || !discountMinimumValue) return amount;

    if (Number(amount) < discountMinimumValue) return amount;

    const discountAmount = Math.floor((discount / 100) * Number(amount));

    const finalValue = Number(amount) - discountAmount;

    return finalValue;
};

export const getAmountBoxHintText = ({
    amountError,
    amount,
    discount,
    discountMinimumValue,
}: GetAmountBoxHintTextParams) => {
    if (!discount || !discountMinimumValue || amountError) return "";

    if (amount !== getDiscountedValue(amount, discount, discountMinimumValue))
        return `Yay! ${discount}% off applied`;

    return "";
};

export const getDefaultSelectedOption = (amountOptions: AmountOption[]): string => {
    let giftDetails;

    try {
        giftDetails = JSON.parse(sessionStorage.getItem("gift-details") as string);
    } catch (e) {
        void 0;
    }

    if (giftDetails) {
        const selectedAmount = giftDetails.originalAmount;
        if (selectedAmount) return selectedAmount;
    }

    const amountOption = amountOptions.find((option) => option.preSelected);
    if (amountOption) return String(amountOption.amount);
    return "";
};

export const isPredefinedAmountSelected = (
    amountOptions: AmountOption[],
    value: string
): boolean => {
    return amountOptions.findIndex((option) => String(option.amount) === value) !== -1;
};

export const getMessageFromSessionData = (defaultMessage: string): string => {
    let giftDetails;

    try {
        giftDetails = JSON.parse(sessionStorage.getItem("gift-details") as string);
    } catch (e) {
        void 0;
    }

    if (giftDetails) {
        const message = giftDetails.receiverMeta?.message;
        if (message) return message;
    }
    return defaultMessage;
};
